import styled from 'styled-components';

export const ActionButtonStyle = styled.a<{variant?: 'orange' | 'white'}>`
	background-color: ${(props) => {
		return {
			orange: '#FF7C54',
			white: '#FFF'
		}[props.variant || 'white']
	}};
	width: 176px;
	height: 30px;
	border-radius: 5px;
	cursor: pointer;
	text-decoration: none;
	color: ${(props) => {
		return {
			orange: '#FFF',
			white: '#001644'
		}[props.variant || 'white']
	}}!important;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	
	font-size: 10px;
	font-style: normal;
	font-weight: 600;
	
	@media all and (min-width: 992px) {
		width: 200px;
		height: 34px;
		font-size: 15px;
	}
`
